import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=09291523"
import script from "./FileReader.vue?vue&type=script&lang=ts"
export * from "./FileReader.vue?vue&type=script&lang=ts"
import style0 from "./FileReader.vue?vue&type=style&index=0&id=09291523&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports